import PropTypes from 'prop-types';
import { useEffect } from 'react';
import trackMixPanelEvent from '../helpers/trackMixPanelEvent';

export default function Logout({ handleLogout }) {
  useEffect(() => {
    trackMixPanelEvent('Logout');
    if (window?.mixpanel) {
      window.mixpanel.reset();
    }
    handleLogout();
  }, [handleLogout]);

  return <div />;
}

Logout.propTypes = { handleLogout: PropTypes.func.isRequired };
